import { unref } from 'vue';
import type { ParsedSizes } from '~/declaration/traits';

export function convertTypeToSize(typeMap, colorMap = {}) {
  const sizeMap = { ...typeMap };

  // set id as the value of typeid for each size
  Object.keys(sizeMap).forEach((sizeId) => {
    const colors = sizeMap[sizeId].sizeToColors[0];

    const allNoColors = Object.values(colorMap).filter((color) => color.name === 'No Color');

    let newColors = sizeMap[sizeId].sizeToColors[0];
    if (colors.length === 1 && allNoColors.find((color) => color.id === colors[0])) {
      newColors = allNoColors.map((color) => color.id);
    }

    sizeMap[sizeId] = {
      ...sizeMap[sizeId],
      id: Number(sizeId),
      name: sizeMap[sizeId].typeName,
      displayName: sizeMap[sizeId].typeName,
      colors: newColors,
    };
  });

  return {
    sizeMap,
    sizeArray: Object.keys(sizeMap).map((sizeId) => sizeMap[sizeId]),
  };
}

function parser(product: MaybeRef<Product>): ParsedSizes {
  const { typeMap } = unref(product).traits.types;
  const { colorMap } = unref(product).traits.colors;
  const { sizeMap, sizeArray } = convertTypeToSize(typeMap, colorMap);

  return {
    selectedSize: sizeArray[0]?.id ?? -1,
    sizeMap,
    sizeArray,
  };
}

export default parser;
